export default __webpack_public_path__ + "static/media/fence-mount-pids-1.105a06a6.jpg";